import React, { useState } from "react";
import { Div, Text, Row, Col, Image, Button, Anchor } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";

const reviews = [
  'Trend - The New Marketing team',
  'Easy to use, great content creators',
  'I LOVE this service'
]

const PricingReviews = ({ content, modalContent }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <Div className="pricing-reviews">
      <WebsiteContainer>
        <Div maxW="49.5rem" className="reviews-list">
          {reviews.map((review) => (
            <Div className="review-item">
              <Div className="rating">
                {[1, 2, 3, 4, 5].map(() => (
                  <Div className="star">
                    <Image src="/images/star.svg" h="9px" />
                  </Div>
                ))}
              </Div>
              <Div className="text">“{review}”</Div>
            </Div>
          ))}
        </Div>
      </WebsiteContainer>
    </Div>
  );
};

export default PricingReviews;
